<script lang="ts">
	import type { FuelPrices } from '../../types';
	import ButtonAddToItinerary from '$lib/components/atoms/button/ButtonAddToItinerary.svelte';
	import Icon from '$lib/components/icons/Icon.svelte';
	import * as c from '$lib/i18n/computedMessages';
	import { getLanguageCode } from '$lib/i18n/language';
	import { formatPastTime } from '$lib/utils/date';
	import { createEventDispatcher } from 'svelte';
	import PoiSummaryTemplate from '../PoiSummaryTemplate.svelte';

	export let name: string;

	export let fuelPrices: FuelPrices | undefined = undefined;
	export let lastUpdated: Date | undefined = undefined;

	const color = 'energy';

	const dispatch = createEventDispatcher<{
		addClick: void;
	}>();
</script>

<PoiSummaryTemplate {name} {color}>
	<svelte:fragment slot="infos">
		<div class="gridcontainer w-full mt-2">
			{#if fuelPrices}
				<!-- eslint-disable-next-line svelte/require-each-key -->
				{#each fuelPrices as { type, price }}
					<div class="flex flex-col">
						<div class="truncate text-bold">
							{c.gasStationFuel(type)}
						</div>
						<div>{price.amount}</div>
					</div>
				{/each}
			{/if}
		</div>
	</svelte:fragment>
	<svelte:fragment slot="buttons">
		<ButtonAddToItinerary
			size="sm"
			onclick={() => dispatch('addClick')}
		/>
	</svelte:fragment>
	<svelte:fragment slot="note">
		{#if lastUpdated}
			{@const [timeText, relativeFlag] = formatPastTime(lastUpdated, getLanguageCode())}
			<div class="flex items-center gap-0.5 text-sm text-neutral truncate">
				{#if relativeFlag}
					<Icon icon="autorenew" />
				{/if}
				{timeText}
			</div>
		{/if}
	</svelte:fragment>
</PoiSummaryTemplate>

<style>
	.gridcontainer {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		grid-auto-rows: 36px;
		gap: 8px;
	}
</style>
